import { UiTypes } from './ui.actions'
import * as R from 'ramda'

export const uiReducers = (state = [], action: any) => {
  switch (action.type) {
    case UiTypes.SET_ACTIVE_POINT: {
      const newState: any = R.clone(state)

      newState.activePoint = action.payload
      return newState
    }
    case UiTypes.SET_DRAGGED_POINT: {
      const newState: any = R.clone(state)

      newState.draggedPoint = action.payload
      return newState
    }
    default:
      return state
  }
}
